import React, { useState } from 'react';

import { Button } from '../../../components/Clickables/Buttons/Button';
import { CheckboxIcon } from '../../../components/Icons/CheckboxIcon';
import { PlusCircleIcon } from '../../../components/Icons/PlusCircleIcon';
import { Text } from '../../../components/Text/Text';
import { useIsTouchDevice } from '../../../helpers/hooks/useIsTouchDevice';
import { DEFAULT_PRO_FEATURES_LIST } from '../constants';

export interface ProFeaturesListProps {
  key: number;
  text: string;
}

export const ProFeaturesList = ({
  className,
  hasShowMore = true,
  proFeaturesListData,
}: {
  className?: string;
  hasShowMore?: boolean;
  proFeaturesListData?: ProFeaturesListProps[];
}) => {
  const [showMoreOpen, setShowMoreOpen] = useState(false);
  const isTouchDevice = useIsTouchDevice();
  const proFeaturesList = proFeaturesListData || DEFAULT_PRO_FEATURES_LIST;
  return (
    <ul className={className}>
      {isTouchDevice && hasShowMore ? (
        <>
          {proFeaturesList.slice(0, 3).map(({ key, text }) => {
            return (
              <li className="flex" key={key}>
                <div className="mr-3">
                  <CheckboxIcon isGreen />
                </div>
                <Text className="mb-0">{text}</Text>
              </li>
            );
          })}

          {showMoreOpen ? (
            proFeaturesList.slice(3).map(({ key, text }) => {
              return (
                <li className="flex" key={key}>
                  <div className="mr-3">
                    <CheckboxIcon isGreen />
                  </div>
                  <Text className="mb-0">{text}</Text>
                </li>
              );
            })
          ) : (
            <Button
              variant="textPrimary"
              className="flex"
              onClick={() => {
                setShowMoreOpen(true);
              }}
            >
              <div className="mr-3 px-[2px]">
                <PlusCircleIcon />
              </div>
              <Text className="mb-0">And more...</Text>
            </Button>
          )}
        </>
      ) : (
        proFeaturesList.map(({ key, text }) => {
          return (
            <li className="flex" key={key}>
              <div className="mr-3">
                <CheckboxIcon isGreen />
              </div>
              <Text className="mb-0">{text}</Text>
            </li>
          );
        })
      )}
    </ul>
  );
};
